<div  *ngIf="viewType !== 'request'  && viewType !== 'approve' " class="dim1 form-wid" [style.height]="(viewType=='edit' ||viewType=='read') ? '114px' : ' 60px'"style="padding-top: 1px;">
    <div *ngIf="viewType=='add' && this.myrole === 'Student'" class="plabel" [dir]="textDir"> {{'Add new student' | translate}}</div>
    <div *ngIf="viewType=='add' && this.myrole === 'Teacher'" class="plabel" [dir]="textDir"> {{'Add new teacher' | translate}}</div>
    <div *ngIf="viewType=='add' && this.myrole === 'SchoolAdmin'" class="plabel" [dir]="textDir"> {{'Add new school administrator'| translate}}</div>
    <div  *ngIf="viewType === 'add' && this.myrole === 'ProjectAdmin'" class="plabel" [dir]="textDir">{{'Add new administrator'| translate}}</div>
    
    <div *ngIf="viewType=='read' || viewType=='edit' ">
        <div class="top-header spaceBtwn">
            <div class="item-middle flexStart">
                <div *ngIf="viewType=='read'">
                    <img *ngIf="data?.logo?.url" [src]="data?.logo?.url?.replace('<FILEBASEURL>', environment.msdpAPIBaseURL)" style="width: 82px;height: 82px;" class="img-circle img-responsive" alt=''>
                    <!-- <img *ngIf="!data?.logo?.url" src='assets/images/upload_image.png' style="width: 70px;height: 70px;" class="img-circle img-responsive" alt=''> -->
                    <div class="userFormLogoInitials" *ngIf="!data?.logo?.url || data?.logo?.url === 'null'">
                        <div class="user-logo-text">{{tabHeadingInitial(this.data?.name)}}</div>
                    </div>                    
                </div>
                <div *ngIf="viewType=='edit'">
                    <app-ctl-logo-upload
                        image=true
                        bucket='admin'
                        type='logo'
                        wrapperClass="ctlInputFile"
                        imgClass="round"
                        [imgSource]="this.myFormGroup.get('logo').value?.url || 'assets/images/upload_image.png'"
                        [myForm]=this.myFormGroup (change)="formChanged($event)"></app-ctl-logo-upload>
                </div>
                <div class="logo-title " [ngClass]="textDir=='ltr'?'marL15':'marR15'">
                    <div class="title marT5" style=" text-transform: capitalize;">{{this.data?.first_name}} {{this.data?.last_name}}</div>
                    <div class="labeltxt marT5">{{this.data?.role?.desc}}</div>
                    <!-- <div class="labeltxt marT5" *ngIf="this.data?.type =='Lead'">Lead {{this.data?.role?.desc}}</div> -->
                    <div *ngIf="viewType=='edit'  && (this.data?.logo?.url || this.myFormGroup.get('logo').value?.url)">
                        <a class="dwnText" (click)="removePhoto();">{{'Remove photo' | translate}}</a>
                    </div>
                </div>
                
            </div>
            <div class="spaceBtwn" *ngIf="viewType=='read' && !newPassword && ( isTeacher !== true && 
            isProjectAdmin !== true && isSchoolAdmin !== true && data?.type!=='Lead')">
                <div class="marT10">
                    <label *ngIf="data?.active === true" class="labeltxt disabled">{{'Archived' | translate}}</label>
                    <label *ngIf="data?.active !== true" class="labeltxt">{{'Archived' | translate}}</label> 
                </div>
                <div class="" [ngClass]="textDir=='ltr'?'padL10':'padR10'">
                    <label class="switch">
                        <input type="checkbox" id="usrStatus" #usrstatus [checked]="data?.active === true" (change)="confirmEnableDisable($event.target.checked)" [dir]="textDir">
                        <i class="ball"></i>
                        <span data-enabled="Active" data-disabled="Archived" style="display: none;"></span>
                    </label>
                </div>
                <div class="marT10"> 
                    <label *ngIf="data?.active !== true" class="padL10 labeltxt disabled" [ngClass]="textDir=='ltr'?'padL10':'padR10'">{{'Active' | translate}}</label>
                    <label *ngIf="data?.active === true" class="padL10 labeltxt" [ngClass]="textDir=='ltr'?'padL10':'padR10'">{{'Active' | translate}}</label>
                </div>
            </div>
        </div>
    </div>
</div>

<div   *ngIf="viewType === 'request'" class="dim2 form-request">
    <div class="plabel" style="font-weight: 500;">{{'New student access request' | translate}}</div>
</div>

<div   *ngIf="viewType === 'approve'" class="dim2 form-approve">
    <div class="plabel" style="font-weight: 500;">{{'Assign this new student' | translate}}</div>
</div>
<section *ngIf="viewType !== 'request' && viewType !== 'approve' " class="eds-white form-wid" [ngClass]="this.myrole === 'Teacher' && viewType=='edit'? 'padB20':''" 
>
   

        <div>       
            <div class="clearfix"></div>
            <div [hidden]="viewType!='read'" [ngClass]="viewType=='read'? 'eds-white pad20': ''">
                <div class="sm-12 flexStart dimensions">
                    <div class="labelwid"> <label class="left">{{'Name' | translate }}</label></div>
                    <div class="txtW" style=" text-transform: capitalize;" [dir]="textDir">
                        <label>{{data?.name}}</label>                
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart" *ngIf="this.myrole !== 'Student' && this.myrole !== 'Teacher'">
                    <div class="labelwid"> <label class="left">{{'Role' | translate }}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label [ngClass]="textDir=='rtl'?'marR10':''">{{data?.role?.desc}}</label>
                        <!-- <label *ngIf="this.data?.type =='Lead'">Lead {{this.data?.role?.desc}}</label> -->
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart" *ngIf="this.myrole && this.myrole === 'Teacher'">
                    <div class="labelwid"> <label class="left">{{'Key subject' | translate }}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label >{{ data?.key_subject?.name}}</label>
                    </div>
                </div>
                
    
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart dimensions" *ngIf="this.myrole && this.myrole !== 'ProjectAdmin'">
                    <div class="labelwid"> <label class="left">{{'Gender' | translate }}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label>{{ data?.gender}}</label>
                    </div>
                </div>
    
    
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart dimensions" *ngIf="myrole == 'Student'">
                    <div class="labelwid"> <label class="left">{{'Date of birth' | translate }}</label></div>

                    <div class="txtW" [dir]="textDir">
                        <label>{{data?.date_of_birth }}</label>
                    </div>
                </div>
                
    
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart dimensions" *ngIf="this.myrole && this.myrole === 'Student'">
                    <div class="labelwid"> <label class="left">{{'Grade' | translate}}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label>{{ data?.class?.grade?.name}}</label>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart dimensions" *ngIf="this.myrole && this.myrole === 'Student'">
                    <div class="labelwid"> <label class="left">{{'Class' | translate}}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label>{{ data?.class?.name}}</label>
                    </div>
                </div>
            
    
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart" *ngIf="this.myrole && this.myrole === 'ProjectAdmin'">
                    <div class="labelwid"> <label class="left">{{'Organization' | translate}}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label>{{ data?.partner?.name}}</label>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart flex-vert-centre" *ngIf="this.myrole && (this.myrole === 'ProjectAdmin' || this.myrole === 'SchoolAdmin' || this.myrole === 'Teacher')">
                    <div class="labelwid"> <label class="left">{{'Email address' | translate}}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label>{{ data?.contact?.email}}</label>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart dimensions flex-vert-centre">
                    <div class="labelwid"> <label class="left">{{'Username' | translate}}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label>{{data?.domain}}\{{ data?.username}}</label>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart dimensions"  
                *ngIf="isTeacher !== true && this.myrole && (this.myrole === 'Student' || this.myrole === 'Teacher') && !this.newPassword"
                
                >
                    <div class="labelwid"> <label class="left">{{'Password' | translate}}</label></div>
                    <div class="txtW"[dir]="textDir" >
                        <label>{{ data?.password}}</label>
                    </div>
                </div>
                <div class="sm-12 marT10 flexStart dimensions" *ngIf="this.myrole && (this.myrole === 'Student' || this.myrole === 'Teacher') && this.newPassword">
                    <div class="labelwid"> <label class="left">{{'New Password' | translate}}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label>{{ this.newPassword}}</label>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart" *ngIf="isTeacher === true">
                    <div class="labelwid"> <label class="left">{{'Status' | translate}}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label>{{ data?.active ? 'Enrolled' : 'Archived'}}</label>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT20 flexStart" *ngIf="isProjectAdmin === true &&  this.isLead==true">
                    <label class="grey_text fine_text" >
                        * {{'The Lead Project Administrator can assign' | translate}}
                    </label> 
                </div>
                <div class="sm-12 marT20 flexStart" *ngIf="isProjectAdmin === true &&  this.isLead==false && this.loggedUserData._id==data._id ">
                    <label class="grey_text fine_text" >
                        * {{'If you need to update' | translate}}
                    </label> 
                </div>
                <div class="clearfix"></div>
            </div>
        </div> 
    <!-- </div>        -->
    <div *ngIf="viewType!=='request' && viewType!=='approve' && viewType!=='read'">
      
        <div #userContainer id="userContainer" class="form-inline" class="eds-white pad20">
            <div class="loading" *ngIf="!loaded"></div>            
            <form *ngIf="loaded" class="form-horizontal modal-height" [ngClass]="this.myrole=='Teacher'? 'mrBtm10': 'mrBtm20'" enctype="multipart/form-data" [formGroup]=myFormGroup>
                <div *ngIf="myrole=='Student' || this.myrole === 'SchoolAdmin'" ></div>
                <div class="marB10" *ngIf="viewType === 'add' && this.myrole === 'ProjectAdmin'">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marB10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Role' | translate}}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div style="width: 330px;" [ngClass]="textDir=='rtl'?'marR8 rtl':''">
                                    <ngx-select-dropdown [multiple]="false" formControlName="role" [options]="roleListData" [config]="roleSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
        
        
                <div class="no-margin">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12
                         flexStart">
                            <div class="labelwid"> <label class="left">{{'First name(s)' | translate}}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <input type="text" class="form-control" minlength=1 maxlength=20 formControlName="first_name" style="width: 330px; text-transform: capitalize;" placeholder="{{'Insert first name(s)' | translate}}" (input)="formChanged($event)" [dir]="textDir">
                                <!-- <div *ngIf="this.myFormGroup.get('first_name').invalid && (this.myFormGroup.get('first_name').dirty || this.myFormGroup.get('first_name').touched)">
                                    <small *ngIf="this.myFormGroup.get('first_name').errors || this.myFormGroup.get('first_name').errors.required">
                                        <span class="alert">Please enter first name.</span>
                                    </small>
                                </div> -->
                            </div>
                        </div>
                    </div>        
                </div>
        
                <div class="no-margin">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Surname' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <input type="text" class="form-control"  maxlength=20 formControlName="last_name"  style="width: 330px;text-transform: capitalize" placeholder="{{'Insert surname' | translate}}" (input)="formChanged($event)" [dir]="textDir">            
                                <!-- <div *ngIf="this.myFormGroup.get('last_name').invalid && (this.myFormGroup.get('last_name').dirty || this.myFormGroup.get('last_name').touched)">
                                    <small *ngIf="this.myFormGroup.get('last_name').errors || this.myFormGroup.get('last_name').errors.maxlength">
                                        <span class="alert">Please enter surname.</span>
                                    </small>
                                </div> -->
                            </div>
                        </div>
                    </div>        
                </div>

                <div class="no-margin" *ngIf="viewType === 'edit' && this.myrole === 'ProjectAdmin'">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left label-light">{{'Role' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div style="width: 330px;" [ngClass]="textDir=='rtl'?'marR8 rtl':''">
                                    <ngx-select-dropdown [multiple]="false" formControlName="role" [options]="roleListData" [config]="roleSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Teacher' && viewType!=='read'">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Key subject' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div style="width: 330px" [ngClass]="textDir=='rtl'?'marR8':''" >
                                    <ngx-select-dropdown [multiple]="false" formControlName="key_subject" [options]="keySubjectListDropdownForTeacher|unique:'name'" [config]="subjectSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- <div class="marT10 marB10" *ngIf="viewType === 'edit' && (this.myrole === 'SchoolAdmin')">
                    <div class="clearfix"></div>
                    <div class="sm-12 marT10 flexStart">
                        <div class="labelwid"> <label class="left">Role</label></div>
                        <div class="txtW">
                            <label >{{this.myrole}}</label>
                        </div>
                    </div>
                </div> -->
                <div class="clearfix"></div>
                <div class="clearfix"></div>
                <div class="no-margin" *ngIf="this.myrole && this.myrole !== 'ProjectAdmin' && viewType !== 'read'">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Gender' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div class="genderWid" [ngClass]="textDir" [dir]="textDir">
                                    <ngx-select-dropdown [multiple]="false" formControlName="gender" [options]="genderList" [config]="genderSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                                </div>
                                <!-- <div style="width: 160px;margin-right:130px;" *ngIf="viewType === 'edit'">
                                    <ngx-select-dropdown [multiple]="false" formControlName="gender" [options]="genderList" [config]="genderSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Student'">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Date of birth' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div class="datepicker" id="dp" #dp>
                                    <input type="text" placeholder="YYYY-MM-DD"  formControlName="date_of_birth" name="datepicker" maxlength="10" class="with-icon"  (change)="datepickerChange($event)" [dir]="textDir">
                                    <div class="suffix icon-inside clickable"><i class="icon icon-calendar"></i></div>
                                  
                                    <div class="calendar closed">
                                      <div class="head">
                                        <i class="icon icon-chevron-left"></i>
                                        <span class="month"></span>
                                        <i class="icon icon-chevron-right"></i>
                                  
                                        <i class="icon icon-chevron-left"></i>
                                        <span class="year"></span>
                                        <i class="icon icon-chevron-right"></i>
                                      </div>
                                      <table class="body">
                                        <!-- the body of the calendar is dynamically generated -->
                                      </table>
                                    </div>
                                  
                                    <input type="hidden" name="selectedDay" id="dob" [dir]="textDir">
                                </div>
                                <!-- <input id="dob" formControlName="date_of_birth" data-provide="datepicker"  type="text" style="width: 150px;" autocomplete="off"
                                class="form-control datepicker" placeholder="Example: 28-4-2016"  (change)="formChanged($event)"> -->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no-margin" *ngIf="viewType === 'add' && this.myrole && this.myrole === 'ProjectAdmin'">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Organization' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div style="width: 330px;"  [ngClass]="textDir=='rtl'?'marR8 rtl':''">
                                    <ngx-select-dropdown [multiple]="false" formControlName="partner" [options]="projPartnerList|pluck: 'partner'" [config]="partnerSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no-margin" *ngIf="viewType === 'edit' && this.myrole && this.myrole === 'ProjectAdmin'">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Organization' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div style="width: 330px;" [ngClass]="textDir=='rtl'?'marR8 rtl':''">
                                    <ngx-select-dropdown [multiple]="false" formControlName="partner" [options]="projPartnerList|pluck: 'partner'" [config]="partnerSelectConfig" (change)="formChanged($event)"></ngx-select-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                        
                        
                <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Student'">
                    <div class="form-inline" >
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'School' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <label [ngClass]="textDir=='rtl'?'marR8':''">{{this.schoolData?.name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
        
                <div class="no-margin" *ngIf='this.myrole && this.myrole === "Student"'>
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Grade' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div style="width: 330px;" [ngClass]="textDir=='rtl'?'marR8 rtl':''">
                                    <ngx-select-dropdown class="ngx-dropup" #gr [multiple]="false" formControlName="grade" [options]="gradeListData" [config]="gradeSelectConfig" (change)="populateClass('grade', gr.value)"></ngx-select-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>        
                </div>
        
                <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Student'">
                    <div class="form-inline">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Class' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <div style="width: 330px;" [ngClass]="textDir=='rtl'?'marR8 rtl':''">
                                    <ngx-select-dropdown class="ngx-dropup" [multiple]="false" formControlName="class" [options]="classListData" [config]="classSelectConfig" (change)="refreshClass($event)"></ngx-select-dropdown>
                            </div>
                            <!-- <div *ngIf="this.myFormGroup.get('class').invalid">
                                <small *ngIf="this.myFormGroup.get('class').errors">
                                    <span class="alert">Please enter valid class.</span>
                                </small>
                            </div> -->
                            </div>
                        </div>
                    </div>        
                </div>
                <div class="no-margin" *ngIf="this.viewType!=='read' && this.myrole && (this.myrole === 'ProjectAdmin' && this.myrole || this.myrole === 'SchoolAdmin' || this.myrole === 'Teacher')">
                    <div class="form-inline" formGroupName="contact">
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'Email address' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <input type="text" formControlName="email" class="form-control"  style="width: 330px;" placeholder="Ex. joe.brown@institution.org"  (input)="formChanged($event)" [dir]="textDir">
        
                                <div *ngIf="this.myFormGroup.get('contact.email').invalid && (this.myFormGroup.get('contact.email').dirty || this.myFormGroup.get('contact.email').touched)">
                                    <small *ngIf='this.myFormGroup.get("contact.email").errors && this.myFormGroup.get("contact.email").errors.pattern'>
                                        <span class="alert">{{'Enter valid email address' | translate }}</span>
                                    </small>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="no-margin" *ngIf="this.myrole && this.myrole === 'Teacher' && this.viewType=='add'">
                    <div class="form-inline" >
                        <div class="clearfix"></div>
                        <div class="sm-12 marT10 flexStart">
                            <div class="labelwid"> <label class="left">{{'School' | translate }}</label></div>
                            <div class="txtW" [dir]="textDir">
                                <label [ngClass]="textDir=='rtl'?'marR8':''">{{this.schoolData?.name}}</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sm-12 marT10 flexStart dimensions opac-5 flex-vert-centre"  *ngIf="viewType=='edit'">
                    <div class="labelwid"> <label class="left">{{'Username' | translate }}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label [ngClass]="textDir=='rtl'?'marR8':''">{{data?.domain}}\{{ data?.username}}</label>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sm-12 marT10 flexStart dimensions opac-5"  
                *ngIf="viewType=='edit' && isTeacher !== true && this.myrole && (this.myrole === 'Student' || this.myrole === 'Teacher') && !this.newPassword"
                
                >
                    <div class="labelwid"> <label class="left">{{'Password' | translate }}</label></div>
                    <div class="txtW" [dir]="textDir">
                        <label [ngClass]="textDir=='rtl'?'marR8':''">{{ data?.password}}</label>
                    </div>
                </div>


                
                 <!-- <div class="marT10" *ngIf="this.myrole && ( this.myrole === 'SchoolAdmin') ">
                    <div class="form-inline flexStart" formGroupName="contact">
                        <div class="labelwid"> <label class="left label-light">School</label></div>
                        <div class="txtW"> 
                            <label class="labeltxt">{{this.schoolData?.name}}</label>
                        </div>                 
                    </div>
                </div>  -->
        
                <div class="alert alert-success" style="width:270px;margin-left:117px;" *ngIf="this.viewType !='edit' && this.myrole && (this.myrole == 'Student' || this.myrole == 'Teacher')">
                    <ng-container *ngIf="user_id && !myFormGroup.controls.username?.value">
                        <a class="btn btn-link" (click)='this.generateUserPass()'>{{'Click here to generate username and password' | translate}}</a>
                    </ng-container>
                    <div *ngIf='data?.username' style="width:100%;height:20px;display: flex;justify-content: space-between;">
                        <label class="label600" style="width:100px;">{{'Username' | translate }}</label>
                        <label class="grey-txt" style="width:100px;margin-top: 7px;">{{this.myFormGroup.get("username").value}}</label>
                    </div>
                    <div *ngIf='data?.password && !newPassword' style="width:100%;height:20px;display: flex;justify-content: space-between;" >
        
                        <label class="label600" style="width:100px;">{{'Password' | translate }}</label>
                        <label class="grey-txt" style="width:100px;margin-top: 7px;">{{data?.password}}</label>
                    </div>
                    <div *ngIf='newPassword' style="width:100%;height:20px;display: flex;justify-content: space-between;" >
        
                        <label class="label600" style="width:100px;">{{'Password' | translate }}</label>
                        <label class="grey-txt" style="width:100px;margin-top: 7px;">{{newPassword}}</label>
                    </div>
                </div>
            </form>
        </div>
    </div>
</section>
    
<ng-container *ngIf="viewType=='request' || viewType=='approve' " style="width:430px">
<!-- [style.height]="viewType=='approve' ? '388px' : '430px'"> -->
    <div #userContainer id="userContainer" class="form-inline">
    <div class="loading" *ngIf="!loaded"></div>
    <form *ngIf="loaded" class="form-horizontal modal-height" enctype="multipart/form-data" [formGroup]=myFormGroup>
     <label *ngIf="viewType=='request'" class="reqtxt">{{'Do you recognise this' | translate}}</label>
     <label *ngIf="viewType=='approve'" class="reqtxt">{{'Please assign this student' | translate}}</label>

     <div [ngClass]="viewType=='request' ? 'bgclr' : ''"  >
        <div class=" flexStart marL20 marT5">
            <div class="labelwid"> <label class="left">{{'First name' | translate}}</label></div>
            <div class="label1">
                <label style=" text-transform: capitalize;">{{data?.first_name}}</label>                
            </div>
        </div>
        <div class=" flexStart marL20 marT5">
            <div class="labelwid"> <label class="left">{{'Surname' | translate}}</label></div>
            <div class="label1">
                <label>{{data?.last_name}}</label>                
            </div>
        </div>

        <div class=" flexStart marL20 marT5">
            <div class="labelwid"> <label class="left">{{'Date of birth' | translate}}</label></div>
            <div class="label1">
                <label>{{data?.date_of_birth}}</label>                
            </div>
        </div>
        <div class=" flexStart marL20 marT5">
            <div class="labelwid"> <label class="left">{{'Gender' | translate}}</label></div>
            <div class="label1">
                <label>{{data?.gender}}</label>                
            </div>
        </div>
        <div class=" flexStart marL20 marT5">
            <div class="labelwid"> <label class="left">{{'School' | translate}}</label></div>
            <div class="label1">
                <label>{{ data?.school?.name}}</label>                
            </div>
        </div>
        <div class=" flexStart marL20 marT5 marB20 flex-vert-centre">
            <div class="labelwid"> <label class="left">{{'Username' | translate}}</label></div>
            <div class="label1">
                <label>{{data?.domain}}\{{ data?.username}}</label>                
            </div>
        </div>
        
    </div>
       

                    
                        <div class="flexStart marL20 marT5 " *ngIf="viewType=='approve'">
                            <div class="labelwid"><label  class="left">{{'Grade' | translate}}</label></div>                            
                            <div class="gradeNgx"  [ngClass]="textDir=='rtl'?'marR8':''">
                                <ngx-select-dropdown class="ngx-dropup" #gr [multiple]="false" formControlName="grade" [options]="gradeListData" [config]="gradeSelectConfig" (change)="populateClass('grade', gr.value)"></ngx-select-dropdown>
                            </div>
                        </div>
                
            
                    <div class="flexStart marL20 marT5 marB40"*ngIf="viewType=='approve'">
                        <div class="labelwid"><label class="left">{{'Class' | translate}}</label></div>
                        <div  class="gradeNgx" [ngClass]="textDir=='rtl'?'marR8':''">
                                        <ngx-select-dropdown class="ngx-dropup" [multiple]="false" (change)="btnAllowStatus($event)" formControlName="class" [options]="classListData" [config]="classSelectConfig"></ngx-select-dropdown>
                                </div>
                            </div>
    </form>
    </div>
</ng-container>
